/* eslint-disable react/function-component-definition */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

import * as amountTrans from '../../translations/help/amount';
import * as colorTrans from '../../translations/help/color';
import * as customTrans from '../../translations/help/customization';
import * as reviewTrans from '../../translations/help/review';

const Help = props => {
  let translations;
  const { path } = props;
  switch (path) {
    case '/colors/:id/':
      translations = colorTrans;
      break;
    case '/amount/':
      translations = amountTrans;
      break;
    case '/print/':
      translations = customTrans;
      break;
    case '/revieworder/':
      translations = reviewTrans;
      break;
    default:
      translations = colorTrans;
  }

  const { toggleAlert, removeCloseBtn } = props;
  let lang = window.config.language_code;
  if (window.config.iso_language_code === 'de-AT') {
    lang = 'at';
  }

  return (
    <div className="alertBox">
      <div
        className="overlay"
        onClick={() => {
          if (!removeCloseBtn) {
            toggleAlert();
          }
        }}
        role="button"
        tabIndex="0"
        style={{ outline: 'none' }}
      />
      <div className="innerBox">
        {!removeCloseBtn && (
          <div
            className="closeButton"
            onClick={() => toggleAlert()}
            role="button"
            tabIndex="0"
            style={{ outline: 'none' }}
          />
        )}
        <div className="contentHolder">
          <h1>{translations[lang].HeadLine}</h1>
          <div>
            <p>{translations[lang].initText}</p>
          </div>
          <div>
            <h2>{translations[lang].Headline2}</h2>
            <div className="highlighted">{translations[lang].q1}</div>
            <p>{translations[lang].a1}</p>
            {translations[lang].q2 !== undefined && (
              <div className="highlighted">{translations[lang].q2}</div>
            )}
            {translations[lang].a2 !== undefined && (
              <p>{translations[lang].a2}</p>
            )}
            {translations[lang].q3 !== undefined && (
              <div className="highlighted">{translations[lang].q3}</div>
            )}
            {translations[lang].a3 !== undefined && (
              <p>{translations[lang].a3}</p>
            )}
          </div>
          <div>
            <div className="highlighted">{translations[lang].o1}</div>
            <p>{translations[lang].o2}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Help;
